
const CONSTANTS = {
    CONTAINER_CLASS: '.pageoverview',
    MORE_WRAPPER_CLASS: '.pageoverview__more',
    MORE_BUTTON_CLASS: 'button',
    ITEM_CLASS: '.pageoverview__item--tile',
    FILTER_ITEM_CLASS: '.pageoverview__filter .filter__body .filter',
    FILTER_BODY_CLASS: '.pageoverview__filter .filter__body',
    FILTER_HEAD_CLASS: '.pageoverview__filter .filter__head .filter',

    ITEMS_PER_PAGE: 12
};

const PageOverviewImpl = function(rootElement) {
    this.lastCategory = 'all';

    const showMoreButton = () => {
        this.more.removeAttribute('disabled');
        this.more.removeAttribute('hidden');
    };
    const hideMoreButton = () => {
        this.more.setAttribute('hidden', '');
    };

    const updateFilter = (category) => {
        this.filter.forEach(filterItem => {
            filterItem.classList.remove('active');
            if (filterItem.dataset.category === category) {
                filterItem.classList.add('active');
                this.filterHead.innerHTML = filterItem.innerHTML;
                this.filterHead.dataset.category = category;
                this.filterBody.removeAttribute('style');
            }
        });
    };

    const filterItems = (filter) => {
        const category = filter?.dataset?.category || this.lastCategory;

        updateFilter(category);

        let itemsToShow = CONSTANTS.ITEMS_PER_PAGE;
        if (!filter) {
            // Load more items if category has changed
            // Count visible items and add 12
            const visibleItems = rootElement.querySelectorAll(CONSTANTS.ITEM_CLASS + ':not([hidden])').length;
            itemsToShow = visibleItems + CONSTANTS.ITEMS_PER_PAGE;
        }

        let visibleItems = 0;
        let hasMore = false;
        for (let i = 0; i < this.items.length; i++) {
            const item = this.items[i];
            const match = (item.dataset.categories.includes(',' + category + ',') || 'all' === category);
            if (visibleItems < itemsToShow && match) {
                item.removeAttribute('hidden');
                visibleItems++;
            }
            else {
                if (match) {
                    hasMore = true;
                }
                item.setAttribute('hidden', '');
            }
        }

        this.lastCategory = category;

        if (hasMore) {
            showMoreButton();
        }
        else {
            hideMoreButton();
        }
    }

    // init
    this.items = rootElement.querySelectorAll(CONSTANTS.ITEM_CLASS);

    this.filterHead = rootElement.querySelector(CONSTANTS.FILTER_HEAD_CLASS);
    this.filterBody = rootElement.querySelector(CONSTANTS.FILTER_BODY_CLASS);
    this.filter = rootElement.querySelectorAll(CONSTANTS.FILTER_ITEM_CLASS);
    this.filter.forEach(filterItem => {
        filterItem.addEventListener('click', () => {
            filterItems(filterItem);
            return false;
        });
    });

    this.more = rootElement.querySelector(CONSTANTS.MORE_WRAPPER_CLASS);
    this.more.querySelector(CONSTANTS.MORE_BUTTON_CLASS)?.addEventListener('click', () => {
        filterItems();
        return false;
    });
    if (this.items.length > CONSTANTS.ITEMS_PER_PAGE) {
        showMoreButton();
    }

    // Automatically filter by hash if page is called with hash
    if (document.location.hash) {
        const filter = rootElement.querySelector(CONSTANTS.FILTER_ITEM_CLASS + '[href="' + decodeURIComponent(document.location.hash) + '"]');
        if (filter) {
            filterItems(filter);
        }
    }
}



const pageoverview = {
    init: () => {
        document.querySelectorAll(CONSTANTS.CONTAINER_CLASS).forEach(element => {
            pageoverview.initElement(element);
        });
    },
    initElement: (element) => {
        new PageOverviewImpl(element)
    }
};

export {pageoverview};
